// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_BuscaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas Busca Response Contract
 *
 * Response for GET /plano_metas/busca/:id - Get a specific goal plan
 *
 * @package Contracts
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlanoMetas_BuscaResponseDados {
id: number
franquia_id: number
data_inicial: string
data_final: string
status: string
created_at: string
updated_at: string
periodo_formatado: string
meta_faturamento?: number
meta_clientes?: number
numero_dias_uteis?: number
ticket_medio_esperado?: number
observacao?: string
created_by?: number
deleted_at?: string
}

export type PlanoMetas_BuscaResponse = ApiResponse<PlanoMetas_BuscaResponseDados>;

registerResponseContract('PlanoMetas_BuscaResponse', {
  id:                    { type: 'number',  required: true },
  franquia_id:           { type: 'number',  required: true },
  data_inicial:          { type: 'string',  required: true },
  data_final:            { type: 'string',  required: true },
  status:                { type: 'string',  required: true },
  created_at:            { type: 'string',  required: true },
  updated_at:            { type: 'string',  required: true },
  periodo_formatado:     { type: 'string',  required: true },
  meta_faturamento:      { type: 'number',  required: false },
  meta_clientes:         { type: 'number',  required: false },
  numero_dias_uteis:     { type: 'number',  required: false },
  ticket_medio_esperado: { type: 'number',  required: false },
  observacao:            { type: 'string',  required: false },
  created_by:            { type: 'number',  required: false },
  deleted_at:            { type: 'string',  required: false },
})
